export default __webpack_public_path__ + "images/1dd1419d1ceb28da4f7603abfc5aa878-no-login.svg";